import { findIcon } from '@/components/icons/icon-catch/icon-catch';
import { useGetTestOptionDetails } from '@/queries/testing-plan.queries';
import { setTitle } from '@/utils';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SectionRefs } from './components/test-details-header/test-details-header.controller';

export default function useTestingPlanDetailsController() {
  const { idTest } = useParams();
  const { data } = useGetTestOptionDetails(idTest || '0');

  const [sectionRefs, setSectionRefs] = useState<SectionRefs>();

  const handleRefsCreated = useCallback((refs: SectionRefs) => {
    setSectionRefs(refs);
  }, []);

  const {
    name,
    how,
    what,
    why,
    insurance,
    cost,
    screeningSpecs,
    screeningTypeName,
    icon,
    alternatives,
  } = data ?? {
    name: '',
    options: [],
    science: [],
    how: '',
    what: '',
    why: [''],
    insurance: '',
    cost: '',
    screeningTypeName: '',
    icon: '',
    alternatives: [],
  };

  const catchIcon = findIcon(icon) ?? 'biomarkers';

  const availableNavItems = [
    ...(what ? ['what'] : []),
    ...(why && why.filter((item) => item.length > 0).length > 0 ? ['why'] : []),
    ...(how ? ['how'] : []),
    'insurance',
    'cost',
    ...(screeningSpecs?.testSensitivity && !isNaN(screeningSpecs.testSensitivity) ? ['value'] : []),
  ];

  useEffect(() => {
    setTitle(`Testing Recommendation - ${(name ?? '').replace('_', ' ')}`);
  }, [name]);

  return {
    name,
    screeningSpecs,
    what,
    how,
    why,
    insurance,
    cost,
    screeningTypeName,
    icon: catchIcon,
    alternatives,
    sectionRefs,
    handleRefsCreated,
    availableNavItems,
  };
}
